import Link from 'next/link';
import styled from 'styled-components';
import type { LocalizedValue, Text } from '@amplience/content-types/typings/h-breadcrumb-node';
import { TypographyStyles, colours, media, spacing } from '@storefront/lib-global/stylings';
import { getLocalizedValue } from '@storefront/lib-global/utils/transformers';

export type ContentBreadcrumbNodeProps = {
  text: Text;
  link?: LocalizedValue;
};

const S = {
  Item: styled.li`
    list-style: none;
    @media ${media.greaterThan('lg')} {
      ${TypographyStyles.Body.Tiny.Regular}
      height: 100%;
      text-transform: capitalize;

      a {
        color: ${colours.BLACK};
        text-decoration: none;
        &:hover,
        &:focus {
          text-decoration: underline;
        }
      }

      &:not(:last-child)::after {
        content: '|';
        display: inline-block;
        height: 11px;
        margin-left: ${spacing.XS};
      }

      &:nth-last-child(2)::after {
        font-weight: 600;
      }

      &:last-child {
        ${TypographyStyles.Body.Tiny.SemiBold}
      }
    }
  `,
};

export function GiftCardBalanceBreadcrumbNode({ text, link }: ContentBreadcrumbNodeProps) {
  const breadcrumbLink = getLocalizedValue(link);
  const breadcrumbText = getLocalizedValue(text);
  return (
    <S.Item>
      {breadcrumbLink ? <Link href={breadcrumbLink}>{breadcrumbText}</Link> : <span>{breadcrumbText}</span>}
    </S.Item>
  );
}
